import { Layout } from 'spa/components/layout'
import { ModuleLoader } from 'spa/components/module_loader/module_loader'
import React from 'react'

const Comparison = React.lazy(() => import('./comparison'))

const display = () => {
  return (
    <Layout fullWidth>
      <ModuleLoader>
        <Comparison />
      </ModuleLoader>
    </Layout>
  )
}

export { display as ComparisonDisplay }

export { Comparison }

export default Comparison
